
import { Component, Vue, Watch } from 'vue-property-decorator'
// import Multiselect from 'vue-multiselect'

import { getLoginReport } from '@/components/admin/users/users.service'
import { PaginationVM, SelectVM, VwLoginReport } from '@/models'
import moment from 'moment'
import xlsx from 'json-as-xlsx'
import { namespace } from 'vuex-class'
import Multiselect from 'vue-multiselect'
import { getResolve } from '@/components/doctors/doctors.service'
const AppModule = namespace('app')

@Component({
  components: {
    Multiselect
  }
})
export default class LoginReport extends Vue {
  @AppModule.Getter
  public _takesLong!: () => boolean
  public expandAllRows = false
  public formExpanded = false
  public showInsurances = false
  public confirmation = ''
  @AppModule.Action('addTakesLong') takesLong: (value: boolean) => Promise<void>

  public fields = [
    // {
    //   key: 'expand',
    //   label: ''
    // },
    {
      key: 'index',
      label: 'Index',
      order: 0
    },
    // 'index',
    // {
    //   key: 'userId',
    //   label: 'User ID'
    // },
    {
      key: 'username',
      label: 'Username',
      sortable: true,
      order: 1
    },
    {
      key: 'fullName',
      label: 'Full Name',
      sortable: true,
      order: 2
    },
    {
      key: 'loginDate',
      label: 'Login Date',
      sortable: true,
      formatter: 'formatDate',
      order: 3
    },
    {
      key: 'firstLoginDate',
      label: 'First Login',
      sortable: true,
      formatter: 'formatDate',
      order: 4
    },
    {
      key: 'lastLoginDate',
      label: 'Last Login',
      sortable: true,
      formatter: 'formatDate',
      order: 5
    },
    {
      key: 'reason',
      label: 'Reason',
      sortable: true,
      order: 6
    },
    {
      key: 'status',
      label: 'User Status',
      sortable: true,
      formatter: 'formatStatus',
      order: 7
    },
    {
      key: 'twoFactor',
      label: '2FA',
      sortable: true,
      formatter: 'formatBool',
      order: 8
    },
    {
      key: 'roles',
      label: 'Role',
      sortable: true,
      order: 9
    }
  ]
  public items: VwLoginReport[] = []

  public perPage = 20
  public pageOptions = [10, 20, 50, 100, 250, 500, 1000]
  public pagination = {} as PaginationVM
  public searchQuery = ''
  public roles: SelectVM[] = []

  public statusList = [
    {
      label: 'Active',
      value: true
    },
    {
      label: 'Inactive',
      value: false
    }
  ]
  public twoFactorList = [
    {
      label: 'Set',
      value: true
    },
    {
      label: 'Not Set',
      value: false
    }
  ]
  public selectedStatusFilter = null
  public selectedTwoFactorFilter = null

  public selectedGender: string | null = null
  public selectedRole: string | null = null
  public selectedRoleFilter: string | null = null
  @Watch('perPage')
  perPageChange() {
    this.getLoginReport()
  }
  public async onPageChange(pageNumber: number) {
    this.expandAllRows = false
    await this.getLoginReport(pageNumber, this.searchQuery)
  }

  public async resetFilters() {
    this.searchQuery = ''
    this.selectedRoleFilter = null
    this.selectedStatusFilter = null
    this.selectedTwoFactorFilter = null
    await this.getLoginReport(1)
  }
  public async exportTable() {
    let items = []
    this.takesLong(true)
    const params = {
      pageNumber: 1,
      pageSize: 999999,
      SearchQuery: this.searchQuery
    }
    if (this.searchQuery) {
      const response = await getLoginReport(params)
      items = response.data
    } else {
      const response = await getLoginReport(params)
      items = response.data
      console.log(response.data)
    }

    const response = await getLoginReport(params)
    items = response.data
    // console.log(items)
    const updatedArray = items.map(obj => {
      const newObj = {}
      // Sort the first array based on the order property
      this.fields.sort((a, b) => a.order - b.order)
      // Get the keys in the order specified by the first array
      const keys = this.fields
        .map(x => x.key)
        .filter(c => c != 'index' || c != 'expand')
      // Sort the keys of the object
      keys.forEach(key => {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          const label = this.fields.find(x => x.key === key).label
          newObj[label.toLowerCase()] = obj[key.toLowerCase()]
        }
      })
      return newObj
    })
    // console.log(updatedArray)
    const data = [
      {
        sheet: 'Login Report History',
        columns: [],
        content: []
      }
    ]

    data[0].columns = this.fields
      .map(c => {
        return {
          label: c.label,
          value: c.key,
          format: c.format
        }
      })
      .filter(c => c.value != 'index')
    // if (this.userRole === Role.Doctor) {
    //   data[0].columns = [
    //     { label: 'NPI', value: 'npi' },
    //     { label: 'Doctor Name', value: 'doctorFullName' }
    //   ].concat(data[0].columns)
    //   // data[0].columns.push()

    //   // this.fields = this.fields.map(c => {
    //   //   return {
    //   //     ...c,
    //   //     key: 'npi',
    //   //     label: 'NPI',
    //   //     order: 2,
    //   //     sortable: false
    //   //   }
    //   // })
    // }
    data[0].content = items.map(c => {
      return {
        ...c,
        firstLoginDate: this.formatDate(c.firstLoginDate?.toString()),
        lastLoginDate: this.formatDate(c.lastLoginDate?.toString()),
        loginDate: this.formatDate(c.loginDate?.toString()),

        status: this.formatStatus(c.status),
        twoFactor: this.formatBool(c.twoFactor)

        // patientStatus: c.patientStatus ? 'Yes' : 'No',
        // dob: this.formatDate(c.dob?.toString()),
        // recordDate: this.formatDate(c.recordDate.toString()),
        // ['raF_TOTAL']: c.raF_TOTAL?.toFixed(2),
        // ['percentage_BFSM']: (c.percentage_BFSM * 100).toFixed(2) + '%',
        // ['percentage_BSSM']: (c.percentage_BSSM * 100).toFixed(2) + '%'
        // npi: c.npi
      }
    })

    const settings = {
      fileName: 'Login Report History', // Name of the resulting spreadsheet
      extraLength: 3, // A bigger number means that columns will be wider
      writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
      writeOptions: {}, // Style options from https://docs.sheetjs.com/docs/api/write-options
      RTL: false // Display the columns from right-to-left (the default value is false)
    }

    xlsx(data, settings) // Will download the excel file
    this.takesLong(false)
  }

  get _pagination() {
    return this.pagination
  }
  private async created() {
    await this.getLoginReport()
  }
  public async getLoginReport(pageNumber = 1, searchQuery = '') {
    const res = await getResolve()
    this.roles = res.roles
    const response = await getLoginReport({
      pageNumber,
      pageSize: this.perPage,
      searchQuery: this.searchQuery,
      roleName: this.selectedRoleFilter?.label,
      active: this.selectedStatusFilter?.value, //this.tri(this.selectedStatusFilter?.value || true),
      twoFA: this.selectedTwoFactorFilter?.value //this.tri(this.selectedTwoFactorFilter?.value || true)
    })
    this.items = response.data
    this.pagination = JSON.parse(response.headers['x-pagination'])
  }

  public async filter() {
    await this.getLoginReport(1, this.searchQuery)
  }
  public async cleanFilter() {
    this.searchQuery = ''
    await this.getLoginReport(1, this.searchQuery)
  }

  public formatDate(value: string) {
    if (value) return moment(value).format('MM/DD/YYYY HH:mm')

    // → "09/08/2025 18:23:01"
  }
  public formatStatus(value: boolean) {
    if (value) {
      return 'Active'
    } else if (value == false) {
      return 'Inactive'
    }
  }
  public formatBool(value: boolean) {
    if (value) {
      return 'Yes'
    } else if (value == false) {
      return 'No'
    }
  }
}
